import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { countData } from "./functions/countData.js";
import { plotBars } from "./functions/plotBars.js";
import { useResizeObserver } from "../../helper/hooks/useResizeObserver.js";
import { Slider } from "../slider/Slider.js";
import styles from "./HistogramSlider.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BAR_WIDTH = 5;
const BAR_PADDING = 5;
export function HistogramSlider({
  data,
  className,
  ...sliderProps
}) {
  const ref = useRef(null);
  const [barCount, setBarCount] = useState(0);
  const normalizedData = countData(data, Math.min(barCount, sliderProps.max - sliderProps.min), sliderProps.min, sliderProps.max);
  const plottedBars = plotBars(normalizedData);
  useResizeObserver(ref, rect => {
    const {
      width
    } = rect;
    const barCount = Math.floor(width / (BAR_WIDTH + BAR_PADDING));
    setBarCount(barCount);
  });
  function isBetweenValues(value) {
    const minValue = sliderProps.values[0];
    if (sliderProps.values.length > 1) {
      const maxValue = sliderProps.values[sliderProps.values.length - 1];
      return value >= minValue && value <= maxValue;
    }
    return value <= minValue;
  }
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: classNames(className, styles.histogramSlider),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.bars,
      children: plottedBars.map((point, index) => /*#__PURE__*/_jsx("div", {
        style: {
          height: point.height
        },
        className: classNames(styles.bar, {
          [styles.active]: isBetweenValues(point.value)
        })
      }, index))
    }), /*#__PURE__*/_jsx(Slider, {
      ...sliderProps
    })]
  });
}